// extracted by mini-css-extract-plugin
module.exports = {"item":"TextBlock-module--item--1B8Fj","title":"TextBlock-module--title--2szNI","perex":"TextBlock-module--perex--2iRuZ","text":"TextBlock-module--text--2MI2I"};